import React from 'react';
import { FormField } from '../../redux/types';
import BooleanInputField from '../base/BooleanInputField';
import { useTurnOffSaleOptionCallback } from '../hooks';
import s from './OfferSectionToggle.scss';

interface Props {}

const OfferSectionToggle: React.FC<Props> = () => {
  const turnOffSaleOption = useTurnOffSaleOptionCallback();

  return (
    <BooleanInputField
      name={FormField.SellAsOffer}
      labelClassName={s['label']}
      size="large"
      tabIndex={-1}
      aria-hidden
      onChange={isNowTrue => {
        if (!isNowTrue) {
          turnOffSaleOption(FormField.SellAsOffer);
        }
      }}
    />
  );
};

OfferSectionToggle.displayName = 'OfferSectionToggle';

export default OfferSectionToggle;
